import { render, staticRenderFns } from "./order-positions.vue?vue&type=template&id=67bd2674&scoped=true"
import script from "./order-positions.vue?vue&type=script&lang=js"
export * from "./order-positions.vue?vue&type=script&lang=js"
import style0 from "./order-positions.vue?vue&type=style&index=0&id=67bd2674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd2674",
  null
  
)

export default component.exports